'use client';

import * as React from 'react';
import Link from 'next/link';
import { motion } from 'motion/react';

import { routes } from '@workspace/routes';
import { buttonVariants } from '@workspace/ui/components/button';
import { cn } from '@workspace/ui/lib/utils';

import { CarCard } from '~/components/cards/car-card';
import { BlurFade } from '~/components/fragments/blur-fade';
import { GridSection } from '~/components/fragments/grid-section';
import { TextGenerateEffect } from '~/components/fragments/text-generate-effect';
import { CarDto } from '~/types/dtos/car-dto';

interface FeaturedCarsProps {
  cars: CarDto[];
}

export function FeaturedCars({ cars }: FeaturedCarsProps): React.JSX.Element {
  return (
    <GridSection>
      <div className="bg-background container flex flex-col px-4 py-20 md:px-6">
        <div className="mb-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-3xl font-semibold tracking-tight md:text-5xl">
              <TextGenerateEffect words="Mașini de lux premium" />
            </h2>
            <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-base">
              Alegeți din colecția noastră de automobile exclusive. Calitate
              superioară și performanță pentru fiecare călătorie.
            </p>
          </motion.div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {cars.map((car, index) => (
            <BlurFade
              key={car.id}
              inView
              delay={0.1 + index * 0.1}
            >
              <CarCard
                key={car.id}
                car={car}
              />
            </BlurFade>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            href={routes.marketing.Cars}
            className={cn(
              buttonVariants({
                variant: 'outline',
                size: 'default'
              }),
              'min-w-[200px] rounded-md'
            )}
          >
            Explorați întreaga colecție
          </Link>
        </div>
      </div>
    </GridSection>
  );
}
